import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { TextField, DateField } from '../../atoms';
import { Row, Col, Button, Spin } from 'antd';
import {
  FORM_REGISTER_REPRESENTATIVE_PERSON,
  formRegisterRepresentativePersonFields,
} from '../../constants/formRegister';
import {
  addMandatePerson,
  updateMandatePerson,
} from '../../actions/actionCreators/registerActionCreators';
import {
  getAddMandatePerson,
  getUpdateMandatePerson,
} from '../../reducers/registerAddMandateReducer';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { parseNumber } from '../../utils/formHelpers';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './validateSchema';
import FormStateToRedux from '../FormStateToRedux';
import isEqual from 'lodash/isEqual';
import './RegisterRepresentPerson.css';

export class RegisterRepresentPerson extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    isLoading: PropTypes.bool,
    addMandatePerson: PropTypes.func.isRequired,
    updateMandatePerson: PropTypes.func.isRequired,
  };

  onSubmit = async (values) => {
    const result = values[formRegisterRepresentativePersonFields.MANDATE_ID]
      ? await this.props.updateMandatePerson(values)
      : await this.props.addMandatePerson(values);
    if (!result?.error) {
      this.props.closeModal();
    }
  };

  render() {
    const { t, isLoading, closeModal, initialValues } = this.props;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit }) => (
          <Spin spinning={isLoading}>
            <form
              className="form-register-representation-person"
              onSubmit={handleSubmit}
            >
              <FormStateToRedux form={FORM_REGISTER_REPRESENTATIVE_PERSON} />
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={formRegisterRepresentativePersonFields.FIRST_NAME}
                    component={TextField}
                    type="text"
                    label={t('representation.first_name_label')}
                    required
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterRepresentativePersonFields.LAST_NAME}
                    component={TextField}
                    type="text"
                    label={t('representation.last_name_label')}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={formRegisterRepresentativePersonFields.PERSONAL_CODE}
                    component={TextField}
                    type="text"
                    parse={parseNumber}
                    label={t('representation.personal_code_label')}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={
                      formRegisterRepresentativePersonFields.MANDATE_DATE_START
                    }
                    component={DateField}
                    showTime
                    label={t('representation.mandate_date_start_label')}
                    className="form-register-representation-person__date-field"
                    required
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={
                      formRegisterRepresentativePersonFields.MANDATE_DATE_END
                    }
                    component={DateField}
                    showTime
                    label={t('representation.mandate_date_end_label')}
                    className="form-register-representation-person__date-field"
                  />
                </Col>
              </Row>
              <div className="component-register-actions">
                <Button
                  className="component-register-actions__button-previous"
                  size="large"
                  onClick={closeModal}
                >
                  {t('representation.person_cancel')}
                </Button>
                <Button
                  className="component-register-actions__button-next"
                  size="large"
                  type="primary"
                  htmlType="submit"
                >
                  {t('representation.person_add')}
                </Button>
              </div>
            </form>
          </Spin>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const isLoading = getLoadingSelector(
    getAddMandatePerson,
    getUpdateMandatePerson
  )(state);

  return {
    isLoading,
  };
};

const mapDispatchToProps = {
  addMandatePerson,
  updateMandatePerson,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterRepresentPerson);
